export type ThemePreference = 'auto' | 'light' | 'dark'

const STORAGE_KEY = 'ja-theme-preference'

/** Home Premium + DARK canonico (01/10/2026): JA ES DARK -- identidad de marca fija del
 * producto cliente, nunca dependiente de Telegram.colorScheme/prefers-color-scheme del
 * sistema para un usuario sin preferencia guardada. El default cambia de 'auto' a 'dark':
 * un usuario nuevo (sin nada en localStorage) obtiene SIEMPRE el tema oscuro oficial. 'auto'
 * y 'light' se conservan como valores válidos -- solo alcanzables si el usuario los elige
 * explicitamente (infraestructura intacta para un futuro toggle de tema, ver ThemeToggle.tsx,
 * hoy no montado en ninguna pagina). */
export function getThemePreference(): ThemePreference {
  const stored = localStorage.getItem(STORAGE_KEY)
  return stored === 'light' || stored === 'auto' ? stored : 'dark'
}

/** Aplica la preferencia guardada al elemento raiz. 'auto' limpia el atributo y deja que
 * `applyTelegramTheme` (dentro de Telegram real) o `prefers-color-scheme` (navegador) decidan. */
export function applyThemePreference(): void {
  const pref = getThemePreference()
  const root = document.documentElement
  if (pref === 'auto') {
    root.removeAttribute('data-theme')
  } else {
    root.setAttribute('data-theme', pref)
  }
}

/** El usuario elige un tema explicito -- gana siempre sobre Telegram/el navegador
 * (ver `applyTelegramTheme` en telegram.ts, que se abstiene si hay preferencia manual).
 *
 * Home Premium + DARK canonico (01/10/2026): BUG REAL encontrado y corregido en este mismo
 * sprint -- antes, elegir 'auto' BORRABA la clave de localStorage (tenía sentido cuando
 * 'auto' era el default implícito de `getThemePreference`); ahora que el default es 'dark',
 * borrar la clave hacía que 'auto' nunca pudiera elegirse de verdad (el siguiente
 * `getThemePreference()` leía "nada guardado" y volvía a caer en 'dark'). 'auto' ahora se
 * persiste explícitamente como cualquier otra preferencia real. */
export function setThemePreference(pref: ThemePreference): void {
  localStorage.setItem(STORAGE_KEY, pref)
  applyThemePreference()
}
